<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="page__inner">
          <h1 class="title title_red page__title">Movement</h1>
          <p class="lead page__lead" style="margin-bottom: auto">We are driven by the energy of movement and continuous development; we actively pursue innovative ideas, inspired by everything around us</p>
        </div>
      </div>
    </div>

    <motion-background />

    <page-footer
      :prev="{ name: 'relations-en' }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import MotionBackground from '@/components/aboutSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '@/views/mixins/route'

export default {
  name: 'motion',
  mixins: [RouteMixin],
  components: {
    MotionBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.motion-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.motion-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
